import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { cn } from '@repo/ui';
import { ArbitrumIcon } from '../icons/chains/ArbitrumIcon';
import { BaseIcon } from '../icons/chains/BaseIcon';
import { EthereumIcon } from '../icons/chains/EthereumIcon';
import { OptimismIcon } from '../icons/chains/OptimismIcon';
export function MultiChainIcon(props) {
  const $ = _c(12);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("grid size-4 grid-cols-2 grid-rows-2 gap-[10%]", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EthereumIcon className="size-full rounded-full" />;
    t2 = <BaseIcon className="size-full rounded-full" />;
    t3 = <OptimismIcon className="size-full rounded-full" />;
    t4 = <ArbitrumIcon className="size-full rounded-full" />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[9] !== rest || $[10] !== t0) {
    t5 = <div className={t0} {...rest}>{t1}{t2}{t3}{t4}</div>;
    $[9] = rest;
    $[10] = t0;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}